module.exports = __webpack_public_path__ + "static/media/accessory6.3d1264ea.webp";